import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { ApprovalDetailPage } from "@/components/supervisor/ApprovalDetailPage";
import { requireFeature, requireSetting } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/leave_/$id")({
  // The page is nothing but the approval chain, which only exists when the org
  // routes leave through supervisors — so the route itself is gated on it.
  beforeLoad: () => {
    requireFeature("leave");
    requireSetting("leave_supervisor_approval_required");
  },
  component: UserLeaveDetailRoute,
});

function UserLeaveDetailRoute() {
  const { id } = useParams({ from: "/user/_layout/leave_/$id" });
  return (
    <SidebarInset>
      <DashboardHeader current={"Leave Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <ApprovalDetailPage variant="user" leaveRequestId={id} />
      </div>
    </SidebarInset>
  );
}
